import { isEmpty } from 'lodash';
import { ReactElement } from 'react';

import { getListItemsClassName } from '@/utils/get-list-items-class-name';
import { getModelURL } from '@/lib/datocms/utils/get-model-url';
import { Icon } from '@/components/icon';
import { Link } from '@/components/link';
import { LinkListIconItemType } from '@/lib/types';

const LinkListWithIconsBlock = ({
  blockAlignmentClass,
  iconItems,
}: {
  blockAlignmentClass: string;
  iconItems: Array<LinkListIconItemType>;
}): ReactElement => {
  return (
    <ul className={blockAlignmentClass}>
      {iconItems.map((item, index) => {
        const iconColour = !isEmpty(item.iconColour) ? item.iconColour : 'Active Blue';
        const content = (
          <div className="item-wrapper">
            <div className="icon-wrapper">{!isEmpty(item.icon) && <Icon name={item.icon} colour={iconColour} />}</div>
            <div className="text-wrapper">
              {!isEmpty(item.title) && <p className="body-2 text-active-blue field-title mb-1">{item.title}</p>}
              {!isEmpty(item.description) && <p className="body-5 mb-0">{item.description}</p>}
            </div>
          </div>
        );
        return (
          <li key={item.id} className={getListItemsClassName(index, iconItems.length)}>
            {/* Double checking here cause typescript doesnt recognize isEmpty as a valid null checker since link is optional */}
            {item.link && !isEmpty(item.link) ? (
              <Link href={getModelURL(item.link)} analytics={{ context: 'Link List', text: item.title }}>
                {content}
              </Link>
            ) : (
              content
            )}
          </li>
        );
      })}
    </ul>
  );
};

export { LinkListWithIconsBlock };
